import { render, staticRenderFns } from "./controlinfo.vue?vue&type=template&id=6a36388f"
import script from "./controlinfo.vue?vue&type=script&lang=js"
export * from "./controlinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports